<template>
    <div>
        <el-row :gutter="20" v-show="id < 0">
            <el-col :span="6">
                <Group ref="group" type="sms" :code="code" @click="changeGroup" @select="moveGroup"></Group>
            </el-col>
            <el-col :span="18">
                <RemoteTable ref="table" :form="form" :table="table" @selection-change="selections = $event">
                    <template #default="{row, property}">
                        <template v-if="property === 'code'">
                            {{$root.getBusinessName(row.code)}}
                        </template>
                        <template v-else-if="property === 'name'">
                            <el-link type="primary" :underline="false" @click="id = row.id">
                                {{row['name']}}
                            </el-link>
                        </template>
                    </template>
                </RemoteTable>
            </el-col>
        </el-row>
        <Template :id="id" :groupId="groupId" v-if="id > -1" @close="closeTemplate"></Template>
    </div>
</template>

<script>
    import RemoteTable from '@/components/RemoteTable'
    import Group from './Group'
    import Template from './Template'

    export default {
        components: {
            RemoteTable,
            Group,
            Template,
        },
        data() {
            return {
                id: -1,
                groupId: 0,
                form: {
                    configs: [
                        {name: "code", label: "业务", type: "cascade", op: "beginwith", value: ""},
                        {name: "name", label: "名称", type: "input", op: "contains", value: ""},
                        {name: "groupId", type: "hidden", value: "0"},
                    ],
                    tools: [
                        {
                            icon: "el-icon-plus", click: () => {
                                this.id = 0;
                            }
                        },
                        {
                            label: "迁移", click: () => {
                                this.$refs.group.showSelect();
                            }
                        }
                    ]
                },
                table: {
                    urlPrefix: "/template",
                    checkbox: true,
                    columns: [
                        {label: "业务名称", name: "code", width: 200},
                        {label: "模板名称", name: "name", width: 200},
                        {label: "模板内容", name: "content"},
                        {label: "创建时间", name: "createTime", width: 150},
                    ],
                    tools: [
                        {
                            icon: "el-icon-copy-document", content: "复制", click: (row) => {
                                this.$axios.get("/template/get/" + row.id).then(result => {
                                    delete result['createTime'];
                                    delete result['id'];
                                    this.$axios.post("/template/save", result).then(() => {
                                        this.$refs.table.load();
                                    })
                                })
                            }
                        }
                    ]
                },
                selections: []
            }
        },
        computed: {
            code() {
                return this.form.configs[0]['value'];
            }
        },
        methods: {
            changeGroup(group) {
              if (group < 0) {
                this.form.configs[2]['value'] = "";
              } else {
                this.form.configs[2]['value'] = group;
              }
                this.groupId = group;
                this.$refs.table.query();
            },
            moveGroup(group) {
                let arr = [];
                this.selections.forEach(selection => {
                    arr.push(selection['id']);
                });
                if (arr.length < 1) {
                    this.$message.warning("请选择需要迁移分组的项！");
                    return;
                }
                this.$axios.post("/group/move", {
                    group: group,
                    type: "sms",
                    ids: arr
                }).then(() => {
                    this.$refs.table.query();
                });
            },
            closeTemplate(reload) {
                this.id = -1;
                if (reload) {
                    this.$refs.table.load();
                }
            }
        }
    }
</script>